import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Map from './map';
import { Portlet, PortletBody } from 'components/partials/content/Portlet';
import PorletHeader, { PorletHeaderTitle } from 'components/porletHeader';
import { getAutoInstallersByCountry } from 'redux/dashboard/selector';

import Button from '@material-ui/core/Button';

const Clientes = ({ data, isLoading }) => (
  <Portlet className="kt-portlet--height-fluid">
    <PorletHeader>
      <PorletHeaderTitle>
        <FormattedMessage id="Instaladores por país" />
      </PorletHeaderTitle>
    </PorletHeader>
    <PortletBody>
      <div className="kt-space-20" />
      <div>{!isLoading && <Map data={data} />}</div>
      <div className="kt-space-20" />
      {/* <div>
        <Button variant="outlined">
          <FormattedMessage id="Export..." />
        </Button>
      </div> */}
    </PortletBody>
  </Portlet>
);

export default connect(getAutoInstallersByCountry)(Clientes);
